<div
  class="form-field"
  [class.submitting]="submitting()"
  [class.error]="errorType() === 'outline' && error()"
  [class.disabled]="disabled()"
>
  @if (label()) {
  <label [for]="id()">{{ label() }}</label>
  }

  <textarea
    [id]="id()"
    [placeholder]="placeholder()"
    [rows]="rows()"
    required
    [(ngModel)]="value"
    [disabled]="disabled()"
  ></textarea>

  @if (errorType() === 'text-bottom') {
  <p [class.error]="error()">
    @if (typeof error() === 'string') {
    {{ error() }}
    } @else {
    {{ "Field is required" }}
    }
  </p>
  }
</div>
